import React, { useCallback, useState, useEffect } from 'react'
import classNames from 'classnames'

import { Image } from '../../components/Image/Image'
import { Button } from '../../components/Button/Button'
import { GameWrapper } from '../../components/GameWrapper/GameWrapper'
import cleanMapImg from '../../resources/cleanMap.png'

import styles from './GameDouble.module.scss'
import img00 from './00-0-img.png'
import img01 from './00-1-img.png'
import img02 from './01-0-img.png'
import img03 from './01-1-img.png'
import img04 from './02-0-img.png'
import img05 from './02-1-img.png'
import img06 from './03-0-img.png'
import img07 from './03-1-img.png'
import img08 from './04-0-img.png'
import img09 from './04-1-img.png'


const IMAGES = [
    img00,
    img01,
    img02,
    img03,
    img04,
    img05,
    img06,
    img07,
    img08,
    img09,
]

function GameDouble() {
    const [win, setWin] = useState(false)
    const [activeIndex, setActiveIndex] = useState(null)
    const [doneParts, setDoneParts] = useState([])

    useEffect(() => {
        if (doneParts.length === 5) {
            setWin(true)
        }
    }, [doneParts, setWin])

    const clickHandler = useCallback((clickedIndex) => {
        if (win) {
            return
        }

        if (activeIndex === null) {
            setActiveIndex(clickedIndex)
        } else if (activeIndex === clickedIndex) {
            setActiveIndex(null)
        } else if (Math.floor(activeIndex / 2) === Math.floor(clickedIndex / 2)) {
            setDoneParts([...doneParts, Math.floor(clickedIndex / 2)])
            setActiveIndex(null)
        }
    }, [win, activeIndex, setActiveIndex, doneParts, setDoneParts])

    return (
        <GameWrapper win={win} people="1">
            <Image src={cleanMapImg} className={styles.bg} />

            {
                IMAGES.map((img, index) => (
                    doneParts.includes(Math.floor(index / 2))
                        ? <div key={img} />
                        : (
                            <Button
                                key={img}
                                src={img}
                                onClick={() => { clickHandler(index) }}
                                className={classNames(
                                    `img-0${index}`,
                                    {
                                        [styles.active]: index === activeIndex,
                                    },
                                )}
                            />
                        )
                ))
            }
        </GameWrapper>
    )
}

GameDouble.propTypes = {}

export { GameDouble }
